import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import OutsourcedUserFteItem from '../../Domain/OutsourcedUserFte/OutsourcedUserFteItem';
import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';
import { describeFtePercentage, toDateOnlyString } from '../../Domain/OutsourcedUserFte/outsourcedUserFteHelpers';

export default class EditFteTrackingWindowDescription {
  static titleForCreate = 'Add FTE Entry';
  static titleForEdit = 'Edit FTE Entry';
  static itemType = OutsourcedUserFteItem;
  static serviceFunction = (item) => {
    const payload = {
      ...item,
      StartDateUtc: toDateOnlyString(item.StartDateUtc),
      EndDateUtc: toDateOnlyString(item.EndDateUtc),
    };
    return payload.OutsourcedUserFteid
      ? OutsourcedUserFteService.Update(payload)
      : OutsourcedUserFteService.Create(payload);
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'FTE Details',
      fields: [
        {
          fieldName: 'UserId',
          label: 'Employee *',
          className: 'col-12',
          type: InputTypesEnum.OutsourcedUserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !item._showUserSelector,
        },
        {
          fieldName: 'HiringOfficeId',
          label: 'Hiring Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forDifferentFieldworkAndHiringOffice,
        },
        {
          fieldName: 'FieldworkOfficeId',
          label: 'Fieldwork Office *',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forDifferentFieldworkAndHiringOffice,
          idFilter: 'HiringOfficeId',
        },
        {
          fieldName: 'Ftepercentage',
          label: 'FTE Split Rate (%) *',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredTextField,
          info: (item) => describeFtePercentage(item.Ftepercentage),
        },
        {
          fieldName: 'StartDateUtc',
          label: 'Start Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'EndDateUtc',
          label: 'End Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forFteEndDateWithinStartMonth,
        },
        // As per Tam�s, this was commented in CD-5080, but we might need it in the future.
        //{
        //  fieldName: 'ApplyFixedMarkupAmount',
        //  label: 'Apply Fixed Markup Amount',
        //  className: 'col-12',
        //  type: InputTypesEnum.Bool,
        //  validityChecker: ValidityHelper.emptyValidityChecker,
        //},
        {
          fieldName: 'ModifiedDesc',
          label: 'Description of Change',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}
